export type FlatListKeyProperties = {
	groupId?: string;
	itemId: string;
};

// this method is used to get the key for the virtualization flat list
export const getFlatListKey = ({ itemId, groupId }: FlatListKeyProperties): string =>
	`${itemId}${groupId ? `::${groupId}` : ''}`;
